import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { downloadReportPDF } from '../../../api/assessment';
import Card from '../../Card';
import Button from '../../Button';

export default function PFinalRoadmap({ report }) {
  const { assessmentId } = useParams();
  const navigate = useNavigate();
  const [downloading, setDownloading] = useState(false);

  const narr = report?.narrative_v2 || {};
  const overallComment = narr.overall_comment || '';
  const roadmap = Array.isArray(narr.action_roadmap) ? narr.action_roadmap : [];

  const handleDownloadPDF = async () => {
    setDownloading(true);
    try {
      const { data } = await downloadReportPDF(assessmentId);
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `AI领导力测评报告_${assessmentId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      let detail = 'PDF 下载失败，请稍后再试';
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          if (json.detail) detail = json.detail;
        } catch { /* ignore parse errors */ }
      }
      alert(detail);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div data-testid="report-page-final">
      {overallComment && (
        <Card style={{ padding: '24px 28px', marginBottom: 24, borderLeft: '4px solid var(--color-primary, #1a3a6b)' }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12, marginTop: 0, color: 'var(--color-primary, #1a3a6b)' }}>
            综合评价
          </h2>
          <p style={{ fontSize: 14, lineHeight: 1.8, margin: 0, color: 'var(--color-text)' }}>
            {overallComment}
          </p>
        </Card>
      )}

      {roadmap.length > 0 && (
        <Card style={{ padding: '24px 28px', marginBottom: 24 }} data-testid="report-page-final-roadmap">
          <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 16, marginTop: 0 }}>行动路线图</h3>
          <ol style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 18 }}>
            {roadmap.map((s, i) => (
              <li key={i} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                <span style={{
                  width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                  background: 'var(--color-primary, #1a3a6b)', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 13, fontWeight: 700,
                }}>{s.step ?? i + 1}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                    <p style={{ fontWeight: 600, fontSize: 14, margin: 0 }}>{s.title || '（待生成）'}</p>
                    {s.timeframe && (
                      <span style={{ fontSize: 11, fontWeight: 600, color: '#7c3aed', background: '#f3e8ff', padding: '2px 10px', borderRadius: 10, whiteSpace: 'nowrap' }}>
                        {s.timeframe}
                      </span>
                    )}
                  </div>
                  {s.detail && (
                    <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.7, margin: 0 }}>
                      {s.detail}
                    </p>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </Card>
      )}

      <Card style={{ padding: '20px 28px' }} data-testid="report-page-final-actions">
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Button variant="secondary" onClick={() => navigate('/')}>返回首页</Button>
          <Button onClick={() => navigate('/assessment/rules')}>再次测评</Button>
          <Button variant="secondary" onClick={() => navigate('/history')}>查看历史</Button>
          <Button
            variant="secondary"
            loading={downloading}
            onClick={handleDownloadPDF}
            style={{ borderColor: '#16a34a', color: '#16a34a' }}
          >
            下载 PDF 报告
          </Button>
        </div>
      </Card>
    </div>
  );
}
